import { render, staticRenderFns } from "./newOrOldCustomer.vue?vue&type=template&id=0410e1ef&scoped=true"
import script from "./newOrOldCustomer.vue?vue&type=script&lang=js"
export * from "./newOrOldCustomer.vue?vue&type=script&lang=js"
import style0 from "./newOrOldCustomer.vue?vue&type=style&index=0&id=0410e1ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0410e1ef",
  null
  
)

export default component.exports